import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import EmployeesGroupDetailsSpaceGroups from 'src/features/employees-groups/components/templates/employees-group-details/space-groups';
import { meilisearchSearchSchema } from 'src/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute(
  '/_layout/tenant/employees/groups/$groupToken/_layout/space-groups',
)({
  component: EmployeesGroupDetailsSpaceGroups,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
